<div class="p-a-xl cipo--height--full cipo--overflow--auto">
    <div class="p-a-xl" fxLayout fxLayoutGap="12px">
        <button mat-raised-button color="accent" (click)="logForm()">Log</button>
        <button mat-raised-button color="primary" (click)="addField()">Add Field</button>
        <mat-checkbox (change)="changeRequired($event.checked)">Required state (all)</mat-checkbox>
        <mat-checkbox (change)="changeReadonly($event.checked)">Readonly state (all)</mat-checkbox>
    </div>

    <div fxLayout.gt-sm="row wrap" fxLayout.lt-md="column" fxLayoutGap="12px">
        @for (control of form.controls | keyvalue; track $index) {
            <div fxFlex.gt-sm="45" class="m-t">
                <cipo-control [control]="control.value" [(fieldData)]="fieldDataMap[control.key]" />
            </div>
        }
    </div>
</div>
